var storeKey = 'forceSecurityPolicySelection';

export function storeForceSecurityPolicySelection (selection) {
    window.localStorage.setItem(storeKey, selection);
}